export default "__VITE_ASSET__6b46f1bc__"